import React, { Component, Fragment } from 'react';
import SelectInput from 'components/Select';
import CustomInput from 'components/InputValidation';
import noImage from 'assets/no_img.svg';

class CustomfitEdit extends Component {
    constructor(props) {
      super(props);
      this.state={
        mealType:props.mealType || '',
        catId:props.catId || '',
        dishId:props.dishId || '',
        qty:props.qty || 0
      }
    }
    componentWillReceiveProps(next){
        if((next.dishId.value!=this.props.dishId.value)||(next.qty!=this.props.qty)){
            this.setState({dishId:next.dishId,qty:next.qty});
        }
    }
    renderAddMeals(){ 
        const { name, catId, dishList, dish, changeDefaultValues, mealType, errors } = this.props;
        const { dishId, qty } = this.state;
        let labelText = `Select ${name}`;
        let dishVal=(dishId&&dish[dishId.value]!=undefined)?dish[dishId.value]:{};
        let basePrice =(dishVal.base_price>0)?(dishVal.base_price/100):0;
        let price =("base_price" in dishVal)? basePrice+((qty/100)*(dishVal.price/100)):0;
        return <Fragment>
            <div className={'col-12'}  style={{marginBottom:'10px'}}>
                  <div className={'select_div'}>
                    <p className={'body-subhead'}>{name}</p>
                    <p className={'body-subhead-small'}>Select {name} & Cooked Weight</p>
                  </div>
              </div>
              <div className={'col-12'}>
                <div className={'dishtype-options'}>
                     <SelectInput
                        placeholder={labelText}
                        list={dishList || {}}
                        value={dishId}
                        name="selectdish"
                        onChange={ (name, val) => {
                            this.setState({ dishId: val },changeDefaultValues(catId,mealType,'dishId',val.value));
                        }}
                    />
                         
                  {errors!='' &&<div className={'col-12'}><p style={{ fontSize: 'small',textAlign:'left',position:'relative',top:"0",color:'#d57669' }} customColor='#f44336'>{errors}</p></div>}
                  <CustomInput
                        placeholder='Select Cooked Weight Gram'
                        value={qty || 0}
                        type='number'
                        name='qty'
                        onChange={(name,val) => this.setState({ qty:val  },changeDefaultValues(catId,mealType,'qty',val))}
                    />
                </div>
            </div>      
                <div className={'customfit-edit-bottom col-12'} style={{marginBottom:'10px'}}>
                  <p className="dish_price">{price.toFixed(2)} AED</p>
                  <p className='dish_cals'>{(dishVal.calories/1000) || 0} Kcal  |  {(dishVal.protein/1000) || 0}g Protein  |  {(dishVal.carb/1000) || 0}g Carbs  |  {(dishVal.fat/1000) || 0}g Fat</p>
              </div>
        </Fragment>;
    }

    renderEditMeals(){
      const { name, catId, dishList, dish, changeDefaultValues, mealType, errors } = this.props;
      const { dishId, qty } = this.state;
      let labelText = `Select ${name}`;
      let dishVal=(dishId&&dish[dishId.value]!=undefined)?dish[dishId.value]:{};
      let basePrice =(dishVal.base_price>0)?(dishVal.base_price/100):0;
      let price =("base_price" in dishVal)? basePrice+((qty/100)*(dishVal.price/100)):0;
      const { image } = dishVal || {};
      const imgUrl = image ? `${image}` : noImage;
      return <Fragment>
            <div className={'col-12'}  style={{marginBottom:'10px'}}>
                  <p bold style={{ fontSize: 'large',textAlign:'center' }} customColor='#555'>{name}</p>
                  <div className="img-holder d-card-img">
                      <div className="image_click ">
                          <img src={imgUrl} /> 
                      </div>
                  </div>
              </div>
              <div className={'col-12'}>
                <div className={'dishtype-options'}>
                        <SelectInput
                            placeholder={labelText}
                            list={dishList || {}}
                            value={dishId}
                            name="selectdish"
                            onChange={ (name, val) => {
                                this.setState({ dishId: val },changeDefaultValues(catId,mealType,'dishId',val.value));
                            }}
                        />                                
                    {errors!='' &&<div className={'col-12'}><p style={{ fontSize: 'small',textAlign:'left',position:'relative',top:"0",color:'#d57669' }} customColor='#f44336'>{errors}</p></div>}
                    <CustomInput
                            placeholder='Select Cooked Weight Gram'
                            value={qty || 0}
                            type='number'
                            name='qty'
                            onChange={(name,val) => this.setState({ qty:val  },changeDefaultValues(catId,mealType,'qty',val))}
                        />
                </div>   
            </div>
                <div className={'customfit-edit-bottom col-12'} style={{marginBottom:'10px'}}>
                  <p style={{ textAlign:'center', marginLeft:'10px' }} customColor='#555'>{(dishVal.calories/1000) || 0} Kcal  |  {(dishVal.protein/1000) || 0}g Protein  |  {(dishVal.carb/1000) || 0}g Carbs  |  {(dishVal.fat/1000) || 0}g Fat</p>
                  <p className="bold" style={{ fontSize: 'large',textAlign:'center' }} customColor='#555'>{price.toFixed(2)} AED</p>
              </div>
        </Fragment>;
    }
    render(){
      const { isEdit } = this.props;
      return <div item className={'customfit-edit-row'}>
            {isEdit && this.renderEditMeals()}
            {!isEdit && this.renderAddMeals()}
      </div>;
    }
}  
export default CustomfitEdit;